// src/hooks/useMasseuseFeedbacks.js
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export function useMasseuseFeedbacks(masseuseId) {
  return useQuery({
    queryKey: ['masseuseFeedbacksForSlider', masseuseId],
    queryFn: async () => {
      const response = await axios.get(
        `https://mydynasty.ca/cd/api/v1/masseuses/${masseuseId}/testimonials/`
      );
      return response.data;
    },
    // Performance improvements:
    // 1. Using gcTime (cacheTime in v5) and staleTime with more reasonable values
    gcTime: 24 * 60 * 60 * 1000, // 24 hours instead of Infinity
    staleTime: 60 * 60 * 1000, // 1 hour instead of Infinity
    // 2. Adding error handling
    retry: 2,
    // 3. Adding a suspense boundary option for easier loading states
    suspense: false,
    // 4. Adding select to transform/filter data if needed
    select: (data) => data?.filter((feedback) => feedback.content?.trim()),
    // 5. Only fetch if we have a valid masseuseId
    enabled: !!masseuseId,
  });
}
